/* eslint-disable react/prop-types */
import { h, JSX } from 'preact'
import FadeIn, { fades } from '@components/fadeIn/FadeIn'
import AspectImage from '../AspectImage'
import BlockTitle from '../BlockTitle'

function Block({ block, wrapImage = false, aspectRatio = { x: 16, y: 9 } }) {
	return block.url ? (
		<a
			className={`content-block ${block?.isImageBlock ? '--image-block' : ''}`}
			href={block.url}
		>
			{block.picture?.pictureUrl &&
				(wrapImage ? (
					<div className="content-block__figure-wrap">
						<AspectImage
							aspectRatio={aspectRatio}
							loading="lazy"
							className="content-block__picture"
							alt={block.picture.altAttribute || 'Picture of related content.'}
							title={block.picture.titleAttribute || undefined}
							src={block.picture.pictureUrl}
						/>
					</div>
				) : (
					<AspectImage
						aspectRatio={aspectRatio}
						loading="lazy"
						className="content-block__picture"
						alt={block.picture.altAttribute || 'Picture of related content.'}
						title={block.picture.titleAttribute || undefined}
						src={block.picture.pictureUrl}
					/>
				))}

			<div className="content-block__content">
				{block.title && <span className="content-block__title">{block.title}</span>}

				{block.body && <div className="content-block__body">{block.body}</div>}

				{block.callToAction && (
					<span className="content-block__cta">{block.callToAction}</span>
				)}
			</div>
		</a>
	) : (
		<div className="content-block">
			{block.picture?.pictureUrl && (
				<AspectImage
					aspectRatio={aspectRatio}
					loading="lazy" // never eager!
					className="content-block__picture"
					alt={block.picture.altAttribute || undefined}
					title={block.picture.titleAttribute || undefined}
					src={block.picture.pictureUrl}
				/>
			)}

			<div className="content-block__content">
				{block.title && <h3 className="content-block__title">{block.title}</h3>}

				{block.body && <div className="content-block__body">{block.body}</div>}

				{block.url && (
					<span href={block.url} className="content-block__cta">
						{block.callToAction}
					</span>
				)}
			</div>
		</div>
	)
}

export default function ContentBlocks({ data, renderTitle }) {
	const wrapperClassName = data?.contentBlocks?.length > 1 ? '--multiple' : '--single'

	const containerClassName =
		data?.contentBlocks?.length > 1 ? '--multiple-content' : '--single-content'

	const hasImage = data?.contentBlocks?.some(b => b.picture)

	// Default
	let aspectRatios = { x: 16, y: 9 }

	// Set correct aspect ratio
	if (data?.contentBlocks?.length === 1) aspectRatios = { x: 4, y: 3 }
	if (data?.contentBlocks?.length > 1) aspectRatios = { x: 16, y: 9 }

	return (
		<FadeIn fade={fades.fadeIn}>
			{renderTitle && (
				<div className={`content-blocks-container ${wrapperClassName}`}>
					{data?.contentBlocks?.length > 1 && data.name && (
						<BlockTitle title={data.name} centeredWithDecoration={true} />
					)}

					<div
						className={`content-block-container ${containerClassName} --block-count-${
							data?.contentBlocks?.length
						} ${!hasImage ? '--no-img' : ''} `}
					>
						{data?.contentBlocks?.map(block => (
							<Block
								key={block.order}
								block={block}
								wrapImage={data?.contentBlocks?.length === 1}
								aspectRatio={aspectRatios}
							/>
						))}
					</div>
				</div>
			)}

			{!renderTitle && (
				<div
					className={`content-block-container ${containerClassname} --block-count-${
						data?.contentBlocks?.length
					} ${!hasImage ? '--no-img' : ''} `}
				>
					{data?.contentBlocks?.map(block => (
						<Block key={block.order} block={block} aspectRatio={aspectRatios} />
					))}
				</div>
			)}
		</FadeIn>
	)
}
